module.exports = __webpack_public_path__ + "static/media/medicos_brasil_background.11002cd2.jpg";